// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
// ReactRouter documentation used : https://reactrouter.com/web/guides/quick-start
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./signUpPage.module.css";
import axios from "axios";

function SignUpPage() {
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSignUp = async (e) => {
    e.preventDefault();

    const user = {
      first_name,
      last_name,
      email,
      password,
    };

    try {
      // eslint-disable-next-line no-unused-vars
      const response = await axios.post(`${apiUrl}/api/users/signup`, user);
      alert("User has been created");
      navigate("/loginPage");
    } catch (error) {
      console.error("Error:", error);
      // error from email already in use
      if (error.response && error.response.status === 400) {
        setErrorMessage("Email is already in use");
        alert("Email is already in use");
      } else {
        setErrorMessage("An error occurred. Please try again.");
      }
    }
  };

  return (
    <div className={styles["signup-container"]}>
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
      <form onSubmit={handleSignUp}>
        <img
          src="/repomerge-logo.png"
          alt="RepoMerge Logo"
          className={styles.logo}
        />
        <div className={styles["form-group"]}>
          <input
            type="text"
            id="firstName"
            value={first_name}
            onChange={(e) => setFirstName(e.target.value)}
            required
            placeholder="First Name:"
          />
        </div>
        <div className={styles["form-group"]}>
          <input
            type="text"
            id="lastName"
            value={last_name}
            onChange={(e) => setLastName(e.target.value)}
            required
            placeholder="Last Name:"
          />
        </div>
        <div className={styles["form-group"]}>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Email:"
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Password:"
          />
        </div>
        <button type="submit">Sign Up</button>
      </form>
      <p className={styles["signin-prompt"]}>
        Already have an account? <a href="/loginPage">Sign In</a>
      </p>
    </div>
  );
}

export default SignUpPage;
